import { AuthModel, UserModel } from "../app/modules/auth";
import { processPost, processGet } from "./api";


export class AuthAPI implements AuthModel{
  //token: string = "";
  constructor(public token:string){

  }
}

export class UserModelAPI implements UserModel{
  id: number = 0;
 
  email: string = "";
  firstname: string = "";
  lastname: string = "";
  fullname?: string;
  role_code?: string;
  role: string = "";
  name: string = "";
  mobile?: string;
  constructor(data:any){
    this.id = data.userId;

    
    this.email = data.email;
    this.name = data.name;
    this.mobile = data.mobile;
    this.fullname = data.name;
    this.role_code = data.role_code;
    this.role = data.role;
 
  }
  

}
const login = async (username:string, password:string) => {
  const data:any = await processPost('auth/login', {username, password})
  let auth = new AuthAPI(data.data.token);
  return auth;
} 


const getLoggedUser = async () => {
  let data:any = await processGet('me');
  let user = new UserModelAPI(data.data);
  return user;

}

const forgot = async (username:string) => {
  const data:any = await processPost('auth/recovery', {username})
  
  return data;
} 

const checkCode = async (recovery_code:string) => {
  const data:any = await processPost('auth/checkrecoveerycode', {recovery_code})
  
  return data;
} 
const resetPassword = async (recovery_code:string,password:string,password_confirm:string) => {
  const data:any = await processPost('auth/resetpassword', {recovery_code,password,password_confirm})
  
  return data;
} 

export { login, getLoggedUser, forgot, checkCode, resetPassword };